import {IsEnum, IsString} from 'class-validator';

import {MembershipRole} from '@shared/enums/workspace.enum';

export class WorkspaceMemberInviteDto {
  @IsString()
  displayName!: string;

  @IsString()
  mobile!: string;

  @IsEnum(MembershipRole)
  role!: MembershipRole;
}
